// ansOrder is 0-based: the apps render the option letter as 0->A, 1->B, 2->C,
// 3->D. This template previously seeded 1..4, so every question created here
// stored answers.answer_order = 1,2,3,4 and rendered as B, C, D, <blank> in the
// mobile app. The backend now re-stamps answer_order from list position on
// insert/update, so these values are belt-and-braces.
export let answer = [
    {
      questionId: 0,
      answerId: 1,
      answer: "",
      correct: false,
      ansOrder: 0,
    },
    {
      questionId: 0,
      answerId: 2,
      answer: "",
      correct: false,
      ansOrder: 1,
    },
    {
      questioId: 0,
      answerId: 3,
      answer: "",
      correct: false,
      ansOrder: 2,
    },
    {
      questionId: 0,
      answerId: 4,
      answer: "",
      correct: false,
      ansOrder: 3,
    },
  ];

  export const answerOptions = [
    { answerId: 1, label: "Option1", value: "Option1", id: 1 },
    { answerId: 2, label: "Option2", value: "Option2", id: 2 },
    { answerId: 3, label: "Option3", value: "Option3", id: 3 },
    { answerId: 4, label: "Option4", value: "Option4", id: 4 },
  ];

  export const config = {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
  };